import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SarcasmScoreRangeFilter from '../../../shared-components/SarcasmScoreRangeFilter/SarcasmScoreRangeFilter';


const SARCASM_FILTER_BUTTON_LABEL = 'Sarcasm Score Range: ';
class DropdownFilter extends Component {
  
  static propTypes = {
    minimumSarcasmScore: PropTypes.number.isRequired,
    maximumSarcasmScore: PropTypes.number.isRequired,
    setFeedModalSarcasmScoreFilter: PropTypes.func.isRequired
  }
  
  constructor(props) {
    super(props);
    this.state = {
      isFilterListActive: false,
      minimumSarcasmScore: 0,
      maximumSarcasmScore: 100
    };
    this.wrapperRef = React.createRef();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentDidMount() {
    this.setState({
      minimumSarcasmScore: this.props.minimumSarcasmScore,
      maximumSarcasmScore: this.props.maximumSarcasmScore
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      minimumSarcasmScore: nextProps.minimumSarcasmScore,
      maximumSarcasmScore: nextProps.maximumSarcasmScore
    });
  }

  handleClickOutside = event => {
    if (event && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
      this.closeDropdownWindow();
    }
  };

  closeDropdownWindow = () => {
    this.setState({
      isFilterListActive: false,
    });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside());
  }

  _returnButtonLabel() {
    const { minimumSarcasmScore, maximumSarcasmScore } = this.state;
    const buttonLabel = `${SARCASM_FILTER_BUTTON_LABEL}${minimumSarcasmScore}% — ${maximumSarcasmScore}%`;
    return buttonLabel;
  }

  render() {
    const {
      isFilterListActive,
      minimumSarcasmScore,
      maximumSarcasmScore
    } = this.state;

    const buttonLabel = this._returnButtonLabel();
    
    return (
      <div className="modal-filter" ref={this.wrapperRef}>
        <div
          className={`input-container ${isFilterListActive ? 'active' : ''}`}
          onClick={() =>
            this.setState(prevState => {
              return {
                isFilterListActive: !prevState.isFilterListActive,
              };
            })
          }
        >
            <div className='dropdown-filter-placeholder'>
                <span>{buttonLabel}</span>
            </div>
            <div className='Dropdown-arrow-wrapper'>
                <span className={`Dropdown-arrow modal-arrow ${isFilterListActive ? 'arrow-open' : ''}`}></span>
            </div>
        </div>
        <div className={`filter-container ${isFilterListActive ? 'show' : ''}`}>
          <SarcasmScoreRangeFilter 
            minimumSarcasmScore={minimumSarcasmScore}
            maximumSarcasmScore={maximumSarcasmScore}
            setFeedModalSarcasmScoreFilter={this.props.setFeedModalSarcasmScoreFilter}
            closeDropdownWindow={() => this.closeDropdownWindow()}
          />
        </div>
      </div>
    );
  }
}

export default DropdownFilter;



// WEBPACK FOOTER //
// ./src/features/home/components/feeds-detail-modal/DropdownFilter.js